"use strict";

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var Graphics = require("../../../graphics");

var solver_1 = require("../../../solver");

var Specification = require("../../../specification");

var common_1 = require("../../../common");

var plot_segment_1 = require("../plot_segment");

var axis_1 = require("../axis");

var map_service_1 = require("./map_service");

var MapPlotSegment =
/*#__PURE__*/
function (_plot_segment_1$PlotS) {
  _inherits(MapPlotSegment, _plot_segment_1$PlotS);

  function MapPlotSegment() {
    var _this;

    _classCallCheck(this, MapPlotSegment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapPlotSegment).apply(this, arguments));
    _this.attributeNames = ["x1", "x2", "y1", "y2"];
    _this.attributes = {
      x1: {
        name: "x1",
        type: Specification.AttributeType.Number
      },
      x2: {
        name: "x2",
        type: Specification.AttributeType.Number
      },
      y1: {
        name: "y1",
        type: Specification.AttributeType.Number
      },
      y2: {
        name: "y2",
        type: Specification.AttributeType.Number
      }
    }; // The map service for this map

    _this.mapService = map_service_1.StaticMapService.GetService();
    return _this;
  }

  _createClass(MapPlotSegment, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x1 = -100;
      attrs.x2 = 100;
      attrs.y1 = -100;
      attrs.y2 = 100;
    }
  }, {
    key: "buildGlyphConstraints",
    value: function buildGlyphConstraints(solver) {
      var _this$getCenterZoom = this.getCenterZoom(),
          _this$getCenterZoom2 = _slicedToArray(_this$getCenterZoom, 3),
          latitude = _this$getCenterZoom2[0],
          longitude = _this$getCenterZoom2[1],
          zoom = _this$getCenterZoom2[2];

      var longitudeData = this.object.properties.longitudeData;
      var latitudeData = this.object.properties.latitudeData;

      if (latitudeData && longitudeData) {
        var latExpr = this.parent.dataflow.cache.parse(latitudeData.expression);
        var lngExpr = this.parent.dataflow.cache.parse(longitudeData.expression);
        var table = this.parent.dataflow.getTable(this.object.table);

        var _this$mercatorProject = this.mercatorProjection(latitude, longitude),
            _this$mercatorProject2 = _slicedToArray(_this$mercatorProject, 2),
            cx = _this$mercatorProject2[0],
            cy = _this$mercatorProject2[1];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = common_1.zipArray(this.state.glyphs, this.state.dataRowIndices)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var glyphState = _ref2[0];
            var index = _ref2[1];
            var row = table.getGroupedContext(index);
            var lat = latExpr.getNumberValue(row);
            var lng = lngExpr.getNumberValue(row);
            var p = this.getProjectedPoints([[lat, lng]])[0];
            solver.addLinear(solver_1.ConstraintStrength.HARD, p[0], [], [[1, solver.attr(glyphState.attributes, "x")]]);
            solver.addLinear(solver_1.ConstraintStrength.HARD, p[1], [], [[1, solver.attr(glyphState.attributes, "y")]]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          x2 = attrs.x2,
          y1 = attrs.y1,
          y2 = attrs.y2;
      return {
        type: "rectangle",
        cx: (x1 + x2) / 2,
        cy: (y1 + y2) / 2,
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1),
        rotation: 0
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "x",
        value: x1,
        attribute: "x1"
      }, {
        type: "x",
        value: x2,
        attribute: "x2"
      }, {
        type: "y",
        value: y1,
        attribute: "y1"
      }, {
        type: "y",
        value: y2,
        attribute: "y2"
      }];
    }
  }, {
    key: "mercatorProjection",
    value: function mercatorProjection(lat, lng) {
      // WebMercator Projection:
      // x, y range: [0, 256]
      var x = 128 / 180 * (180 + lng);
      var y = 128 / 180 * (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat / 180 * Math.PI / 2)));
      return [x, y]; // // Bing's version as of here: https://msdn.microsoft.com/en-us/library/bb259689.aspx
      // // Same as Google's Version
      // let sin = Math.sin(lat / 180 * Math.PI);
      // let x1 = (lng + 180) / 360 * 256;
      // let y1 = (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * 256;
      // console.log((x - x1).toFixed(8), (y - y1).toFixed(8));
    } // Get (x, y) coordinates based on longitude and latitude

  }, {
    key: "getProjectedPoints",
    value: function getProjectedPoints(points) {
      var _this2 = this;

      var attrs = this.state.attributes;

      var _this$getCenterZoom3 = this.getCenterZoom(),
          _this$getCenterZoom4 = _slicedToArray(_this$getCenterZoom3, 3),
          cLatitude = _this$getCenterZoom4[0],
          cLongitude = _this$getCenterZoom4[1],
          zoom = _this$getCenterZoom4[2];

      var _this$mercatorProject3 = this.mercatorProjection(cLatitude, cLongitude),
          _this$mercatorProject4 = _slicedToArray(_this$mercatorProject3, 2),
          cX = _this$mercatorProject4[0],
          cY = _this$mercatorProject4[1];

      var scale = Math.pow(2, zoom);
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return points.map(function (p) {
        var _this2$mercatorProjec = _this2.mercatorProjection(p[0], p[1]),
            _this2$mercatorProjec2 = _slicedToArray(_this2$mercatorProjec, 2),
            x = _this2$mercatorProjec2[0],
            y = _this2$mercatorProjec2[1];

        return [(x - cX) * scale + (x1 + x2) / 2, -(y - cY) * scale + (y1 + y2) / 2];
      });
    }
  }, {
    key: "getCenterZoom",
    value: function getCenterZoom() {
      var attrs = this.state.attributes;
      var props = this.object.properties;
      var minLongitude = -180;
      var maxLongitude = 180;
      var minLatitude = -50;
      var maxLatitude = 50;

      if (props.latitudeData != null) {
        minLatitude = props.latitudeData.domainMin;
        maxLatitude = props.latitudeData.domainMax;
      }

      if (props.longitudeData != null) {
        minLongitude = props.longitudeData.domainMin;
        maxLongitude = props.longitudeData.domainMax;
      }

      var _this$mercatorProject5 = this.mercatorProjection(minLatitude, minLongitude),
          _this$mercatorProject6 = _slicedToArray(_this$mercatorProject5, 2),
          xMin = _this$mercatorProject6[0],
          yMin = _this$mercatorProject6[1];

      var _this$mercatorProject7 = this.mercatorProjection(maxLatitude, maxLongitude),
          _this$mercatorProject8 = _slicedToArray(_this$mercatorProject7, 2),
          xMax = _this$mercatorProject8[0],
          yMax = _this$mercatorProject8[1]; // Find the appropriate zoom level for the given box.


      var scaleX = Math.abs(Math.abs(attrs.x2 - attrs.x1) / Math.abs(xMax - xMin));
      var scaleY = Math.abs(Math.abs(attrs.y2 - attrs.y1) / Math.abs(yMax - yMin));
      var scale = Math.min(scaleX, scaleY);
      var zoom = Math.floor(Math.log2(scale));
      var latitude = (minLatitude + maxLatitude) / 2;
      var longitude = (minLongitude + maxLongitude) / 2;
      return [latitude, longitude, zoom];
    }
  }, {
    key: "getPlotSegmentGraphics",
    value: function getPlotSegmentGraphics(glyphGraphics) {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;

      var _this$getCenterZoom5 = this.getCenterZoom(),
          _this$getCenterZoom6 = _slicedToArray(_this$getCenterZoom5, 3),
          latitude = _this$getCenterZoom6[0],
          longitude = _this$getCenterZoom6[1],
          zoom = _this$getCenterZoom6[2];

      var width = x2 - x1;
      var height = y2 - y1;
      var img = {
        type: "image",
        src: this.mapService.getImageryURLAtPoint({
          center: {
            latitude: latitude,
            longitude: longitude
          },
          type: this.object.properties.mapType,
          zoom: zoom,
          width: width,
          height: height,
          resolution: "high"
        }),
        x: x1,
        y: y1,
        width: width,
        height: height
      };
      return Graphics.makeGroup([img, glyphGraphics]);
    }
  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2,
          x = attrs.x,
          y = attrs.y;
      var zones = [];
      zones.push({
        type: "line",
        p1: {
          x: x2,
          y: y1
        },
        p2: {
          x: x1,
          y: y1
        },
        title: "Longitude",
        dropAction: {
          axisInference: {
            property: "longitudeData"
          }
        }
      });
      zones.push({
        type: "line",
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x1,
          y: y2
        },
        title: "Latitude",
        dropAction: {
          axisInference: {
            property: "latitudeData"
          }
        }
      });
      return zones;
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var rows = this.parent.dataflow.getTable(this.object.table).rows;
      var x1 = attrs.x1,
          x2 = attrs.x2,
          y1 = attrs.y1,
          y2 = attrs.y2;
      var h = [{
        type: "line",
        axis: "y",
        value: y1,
        span: [x1, x2],
        actions: [{
          type: "attribute",
          attribute: "y1"
        }]
      }, {
        type: "line",
        axis: "y",
        value: y2,
        span: [x1, x2],
        actions: [{
          type: "attribute",
          attribute: "y2"
        }]
      }, {
        type: "line",
        axis: "x",
        value: x1,
        span: [y1, y2],
        actions: [{
          type: "attribute",
          attribute: "x1"
        }]
      }, {
        type: "line",
        axis: "x",
        value: x2,
        span: [y1, y2],
        actions: [{
          type: "attribute",
          attribute: "x2"
        }]
      }, {
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x2,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x1,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }, {
        type: "point",
        x: x2,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }];
      return h;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(m) {
      var props = this.object.properties;
      var widgets = [].concat(_toConsumableArray(axis_1.buildAxisWidgets(props.latitudeData, "latitudeData", m, "Latitude")), _toConsumableArray(axis_1.buildAxisWidgets(props.longitudeData, "longitudeData", m, "Longitude")), [m.sectionHeader("Map Style"), m.inputSelect({
        property: "mapType"
      }, {
        type: "dropdown",
        showLabel: true,
        labels: ["Roadmap", "Satellite", "Hybrid", "Terrain"],
        options: ["roadmap", "satellite", "hybrid", "terrain"]
      })]);
      return widgets;
    }
  }]);

  return MapPlotSegment;
}(plot_segment_1.PlotSegmentClass);

MapPlotSegment.classID = "plot-segment.map";
MapPlotSegment.type = "plot-segment";
MapPlotSegment.metadata = {
  iconPath: "plot-segment/map"
};
MapPlotSegment.defaultMappingValues = {};
MapPlotSegment.defaultProperties = {
  mapType: "roadmap"
};
exports.MapPlotSegment = MapPlotSegment;